/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState, createContext } from 'react';
import { Alert } from '@one-thd/sui-atomic-components';

// type: success, warning, error, info
// https://brand.homedepot.com/site/knapsack-nucleus/latest/pattern/alerts?subPageId=overview
const initialState = {};
const alertContextState = {
  showAlert: () => {},
  dismissAlert: () => {},
  clearAlert: () => {}
};
export const AlertContext = createContext(alertContextState);

export const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState(initialState);

  const showAlert = (_alertState) => {
    setAlertState((prevState) => ({
      ...prevState,
      ..._alertState
    }));
  };

  const dismissAlert = (type) => {
    const currentAlert = alertState[type];
    setAlertState((prevState) => {
      const _prev = { ...prevState };
      delete _prev[type];
      return _prev;
    });
    if (currentAlert) {
      currentAlert.onClose();
    }
  };

  const clearAlert = () => {
    setAlertState(initialState);
  };

  return (
    <AlertContext.Provider
      value={{
        showAlert,
        dismissAlert,
        clearAlert
      }}
    >
      <div className="sui-flex sui-flex-col sui-w-full">
        {Object.keys(alertState || {}).map((alertType) => {
          const alertProps = {
            status: alertType,
            key: alertType
          };
          if (alertState[alertType]?.onClose) {
            alertProps.onClose = () => {
              dismissAlert(alertType);
            };
          }
          return (
            <Alert data-testid={`alert-${alertType}`} {...alertProps}>
              {alertState[alertType]?.message}
            </Alert>
          );
        })}
      </div>
      {children}
    </AlertContext.Provider>
  );
};
